import React from 'react';

const AbsenceContainer = () => {
  return <>{'Absence'}</>;
};

export { AbsenceContainer };
